var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.6457 19.7794C33.0061 19.7794 32.1589 19.7653 31.104 19.7653C28.5314 19.7653 26.4161 17.636 26.4161 15.0393V10.4833C26.4161 10.1248 26.13 9.83301 25.7751 9.83301H18.2817C14.7847 9.83301 11.9583 12.7032 11.9583 16.2208V31.4853C11.9583 35.1758 14.9194 38.1663 18.5735 38.1663H29.7321C33.2165 38.1663 36.0416 35.3146 36.0416 31.7942V20.4169C36.0416 20.0571 35.7568 19.7667 35.4005 19.7681C34.8016 19.7723 34.0834 19.7794 33.6457 19.7794Z",
    fill: "#0070D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.7856 10.6366C29.3621 10.196 28.6226 10.4992 28.6226 11.1098V14.8455C28.6226 16.4124 29.9131 17.7015 31.48 17.7015C32.4674 17.7129 33.8387 17.7157 35.0032 17.7129C35.5996 17.7115 35.9028 16.9989 35.4891 16.5682C33.9946 15.0141 31.3185 12.229 29.7856 10.6366Z",
    fill: "#0070D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4255 28.0986C28.0077 28.0987 28.4812 28.5721 28.4812 29.1543C28.481 29.7364 28.0076 30.2079 27.4255 30.208H19.7126C19.1307 30.2078 18.6591 29.7363 18.6589 29.1543C18.6589 28.5722 19.1306 28.0989 19.7126 28.0986H27.4255ZM24.5085 21.0234C25.0907 21.0235 25.5642 21.4969 25.5642 22.0791C25.5641 22.6612 25.0906 23.1327 24.5085 23.1328H19.7126C19.1306 23.1327 18.6591 22.6611 18.6589 22.0791C18.6589 21.4969 19.1305 21.0236 19.7126 21.0234H24.5085Z",
    fill: "#0070D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiicon1);
export default __webpack_public_path__ + "static/media/kpiicon1.d2244cbabaf1d142de499973afa55230.svg";
export { ForwardRef as ReactComponent };